import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * FileClock icon
 *
 * @category Files/Forms/Editing
 */
const FileClock = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M27.794 10.756C26.579 9.212 22.11 5.05 20.73 3.6c-.354-.318-.613-.542-1.097-.566-1.993-.059-4.563 0-6.685-.023-2.323.059-4.021-.401-5.412 1.485-.472.696-.625 1.462-.614 2.276v6.945c-.07 1.32.224 2.028-.33 2.948-.412.566-.99 1.096-1.391 1.71-3.408 5.105 1.155 11.378 6.968 10.552h11.025c2.405.283 4.787-.872 4.74-3.584-.094-2.323.189-10.706-.106-14.515zM20.577 5.25c1.18.53 2.866 2.736 3.997 3.726.319.424 1.321 1.073.92 1.521-1.485.377-3.938.26-4.716-1.108-.519-.955-.802-3.266-.271-4.115l.082-.024zM5.155 21.934c.082-3.773 4.657-6.544 8.041-4.68 3.066 1.438 4.092 5.612 1.934 8.217-3.066 4.198-10.058 1.816-9.987-3.313v-.212zm21.283 4.386c-.955 1.863-3.337 1.333-5.106 1.404-12.345.365-.354-.779-4.905-9.186a6.42 6.42 0 0 0-5.105-3.112c-.944-.189-2.17.424-2.936-.236-.13-.153-.19-.377-.213-.625-.082-2.464-.153-5.86.083-8.36.66-3.23 5.388-1.662 8.171-2.04 2.004 0 3.066-.26 2.889 2.016 0 .802.035 1.722.141 2.547.271 2.264 2.535 2.89 4.516 2.877.86.047 1.887-.035 2.358.342.213.165.319.401.354.672.036 1.439.024 4.092.047 6.745-.07 2.983.165 5.247-.212 6.815l-.07.142z"
        />
        <path
          fill="currentColor"
          d="M10.005 21.759V18.95a.59.59 0 0 1 1.18 0v2.808a.59.59 0 0 0 .325.527l1.707.854a.59.59 0 1 1-.528 1.054l-1.706-.853c-.6-.3-.978-.912-.978-1.582"
        />
      </svg>
    );
  }
);

FileClock.displayName = 'FileClock';

export { FileClock };
